module.exports = __webpack_public_path__ + "assets/img/popup_chart-1.9e54ea8d.png";